import api from './api';
import { API_ENDPOINTS } from '../utils/constants';

export const setToken = (token) => {
  localStorage.setItem('admin_token', token);
};

export const getToken = () => {
  return localStorage.getItem('admin_token');
};

export const removeToken = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
};

export const setUser = (user) => {
  localStorage.setItem('admin_user', JSON.stringify(user));
};

export const getUser = () => {
  try {
    const user = localStorage.getItem('admin_user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

export const isAuthenticated = () => {
  const token = getToken();
  const user = getUser();
  return !!token && user?.is_admin === true;
};

export const login = async (email, password) => {
  try {
    // Create form data for OAuth2PasswordRequestForm
    const formData = new URLSearchParams();
    formData.append('username', email);  // Backend expects 'username', not 'email'
    formData.append('password', password);
    
    const response = await api.post(API_ENDPOINTS.LOGIN, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    
    const { access_token } = response.data;
    setToken(access_token);
    
    // Get user details
    const userResponse = await api.get(API_ENDPOINTS.ME, {
      headers: {
        Authorization: `Bearer ${access_token}`
      }
    });
    const userData = userResponse.data;
    
    // Check if user is admin
    if (!userData.is_admin) {
      removeToken();
      return { 
        success: false, 
        error: 'Access denied. Admin only.' 
      };
    }
    
    setUser(userData);
    return { success: true, user: userData };
  } catch (error) {
    console.error('Login error:', error);
    removeToken();
    
    let errorMessage = 'Login failed';
    if (error.response?.data?.detail) {
      errorMessage = error.response.data.detail;
    } else if (error.response?.status === 422) {
      errorMessage = 'Invalid login credentials format';
    } else if (error.response?.status === 401) {
      errorMessage = 'Incorrect email or password';
    }
    
    return { 
      success: false, 
      error: errorMessage 
    };
  }
};

export const logout = async () => {
  removeToken();
  // Optional: Call logout endpoint if your API has one
  // try {
  //   await api.post(API_ENDPOINTS.LOGOUT);
  // } catch (error) {
  //   console.error('Logout error:', error);
  // }
};

export const getCurrentUser = async () => {
  try {
    const token = getToken();
    if (!token) {
      return { success: false, error: 'No token found' };
    }
    
    const response = await api.get(API_ENDPOINTS.ME, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    const userData = response.data;
    setUser(userData);
    return { success: true, user: userData };
  } catch (error) {
    if (error.response?.status === 401) {
      logout();
    }
    return { 
      success: false, 
      error: error.response?.data?.detail || 'Failed to get user' 
    };
  }
};

export const updateUser = async (userData) => {
  try {
    // Update user in localStorage
    const currentUser = getUser();
    const updatedUser = { ...currentUser, ...userData };
    setUser(updatedUser);
    
    // Optional: Call API to update user
    // const response = await api.put(API_ENDPOINTS.ME, userData);
    
    return { success: true, user: updatedUser };
  } catch (error) {
    return { 
      success: false, 
      error: error.response?.data?.detail || 'Failed to update user' 
    };
  }
};